function prepareHeaders(headers: Headers) {
  const token =
    import.meta.env.VITE_DEV_AUTH_TOKEN || localStorage.getItem('userToken')

  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  headers.set('Accept', 'application/json')

  return headers
}

export { prepareHeaders }
